import { render } from "./NovedadesBejerman.vue?vue&type=template&id=0932177a"
import script from "./NovedadesBejerman.vue?vue&type=script&lang=js"
export * from "./NovedadesBejerman.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__